/*
  Collection of generic validation rules for create validation configuration.
  All functions are exported for validation config's consumption.
*/
const DEFAULT_STRING_MAX_LENGTH = 150;

/*
  Is Field (String) Not Empty.
  Check if string contains empty space.
*/
export const required = (data) => {
  console.log("required");
  console.log(data);
  if(data === null || data === ''){ return true };
  return data.match(/^ *$/) !== null;
}

/*
  Mandatory field with Conditional check.
*/
export const requiredIfFieldIs = (data, field, value) => {
  return function(obj) {
    if(obj[field].value == value) {
      if( data === null ){ return true };
      return data.match(/^ *$/) !== null;
    }
    return false;
  }
}

/*
  Mandatory field is not empty
*/
export const requiredIfNotEmpty = (data, field) => {
  return function(obj) {
    if(obj[field].value !== ''){
      console.log(field,' not empty')
      return required(data);
    }
    return false;
  }
}

/*
  Required only if the obj state field contains a value
*/
export const requiredIfFieldContains= (data, field, value) => {
  return function(obj) {
    if( value.includes(obj[field].value) ) {
      if( data === null ){ return true };
      return data.match(/^ *$/) !== null;
    }
    return false;
  }
}

/*
  Is Field (String) contains numerical and dash value only.
  For Contact numbers.
*/
export const contactNumberFormat = (data) => {
  if(typeof data !== 'string'){ return true };
  return /^(\d+-?)+\d+$/.test(data);
}

/*
  Is Field (String) contains numerical value.
  Check if string value is numeric and can be parse to number (float/integer)
*/
export const numeric = (data) => {
  if( data === null){ return false };
  if( typeof data === 'number' ){ return false };
  if( typeof data !== "string" ){ return false };
  data = data.trim();
  return isNaN(data) && isNaN(parseFloat(data));
}

/*
  Is Field (String) a valid email address format
  Check if the string value is a value email address format
*/
export const validEmailFormat = (data) => {
  if(data ===  null){ return false };
  if(typeof data !== 'string'){ return false };
  data = data.trim();
  return !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(data);
}

/*
  Is Field (String) follows the min max format
  Check if string length is on the specified range
*/
export const minMaxLengthString = (string, min, max) => {
  if(string == null){ return true };
  return (string.length < min || string.length > max);
}


/*
  Default String limit (see consts in the upper section)
*/
export const defaultStrMaxLength = (string) => {
  return minMaxLengthString(string, 0, DEFAULT_STRING_MAX_LENGTH);
}

/*
  No special characters
  Check if the string has no special characters and all char are from [A-Z. a-z] only.
*/
export const alphaCharacters = (string) => {
  if(typeof string !== 'string'){ return true };
  if(string === ''){ return false };
  const ret = !(/^[ A-Za-z]+$/.test(string));
  return ret;
}

/*
  No special characters
  Check if the string has no special characters and all char are from [A-Z. a-z] only.
*/
export const alphaNumeric = (string) => {
  if(typeof string !== 'string'){ return true };
  return !/^[a-z0-9]+$/i.test(string);
}

/*
  Check if date less than the specified date
*/
export const dateLessThan = (string, date) => {
  const dt = new Date(string);
  const dt2 = new Date(date);
  return dt < dt2;
}


/*
  Check if date less than the specified date
*/
export const dateNotLessThan = (string, field) => {
  return function(obj){
    const d1 = new Date(string);
    const d2 = new Date(obj[field].value);
    return d1 <= d2;
  }
}

/*
  Check if date is less than the current date
*/
export const dateNotLessThanToday = (string) => {
  if(typeof string === 'string'){
    const today = new Date();
    const dt = new Date(string);
    return today > dt;
  }
  return true;
}

/*
  Check if string does not end with 'B'
*/
export const notEndsWithB = (string) => {
  if(typeof string !== 'string'){ return false };
  if(string === ''){ return false };
  return string.endsWith('B') || string.endsWith('b');
}

